import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { PasswordResetPage } from 'features/auth'

export const Route = createFileRoute('/_unauthenticated/reset/')({
  component: PasswordResetPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Forgot Password'),
      },
      {
        name: 'description',
        content:
          'Reset your password to log in to the Fingerprint dashboard. Identify every visitor, stop fraud, and build safer web and mobile experiences.',
      },
    ],
  }),
})
